import httpClientHub from '@/libs/http-client-hub'

const BASE_PATH = '/v1/common/peekai/nudge'

function getReportResult (response) {
  const data = response.data
  if (response.status < 200 || response.status >= 300 || !data || data.success !== true || !data.result) {
    const apiError = data && data.error
    const error = new Error((apiError && apiError.message) || 'Failed to load PeekAI Nudge report')
    error.code = (apiError && apiError.code) || response.status
    if (apiError && apiError.reportId) error.reportId = apiError.reportId
    throw error
  }
  return data.result
}

/**
 * 피카이 리포트 생성 또는 재시도
 * POST /v1/common/peekai/nudge
 * @param {{userNum: string, domain: string, sid: string, serviceType: 'ba'|'beusable', lang?: string}} params
 * 응답의 id를 이후 상태 및 HTML 조회에 사용합니다.
 */
export function createPeekaiReport ({ userNum, domain, sid, serviceType, lang = 'ko' }) {
  if (typeof userNum !== 'string' || !userNum.trim()) {
    return Promise.reject(new Error('userNum must be a non-empty string'))
  }
  return httpClientHub.post(BASE_PATH, { userNum, domain, sid, serviceType, lang }).then(getReportResult)
}

/**
 * 인증된 Beusable 계정의 기존 샘플 리포트 확인
 * GET /v1/common/peekai/nudge/availability
 */
export function getPeekaiReportAvailability () {
  return httpClientHub.get(`${BASE_PATH}/availability`).then(getReportResult)
}

/**
 * 피카이 리포트 진행 상태 조회
 * GET /v1/common/peekai/nudge/{reportId}
 */
export function getPeekaiReportStatus (reportId) {
  const url = `${BASE_PATH}/${encodeURIComponent(reportId)}`
  return httpClientHub.get(url).then(getReportResult)
}

/**
 * 피카이 완료 리포트 HTML 조회
 * GET /v1/common/peekai/nudge/{reportId}/html
 */
export function getPeekaiReportHtml (reportId) {
  const url = `${BASE_PATH}/${encodeURIComponent(reportId)}/html`
  return httpClientHub.get(url, {
    headers: { Accept: 'text/html' },
    responseType: 'text'
  }).then(response => {
    const contentType = (response.headers && response.headers['content-type']) || ''
    if (response.status < 200 || response.status >= 300 || contentType.indexOf('text/html') === -1) {
      let errorData = response.data
      if (typeof errorData === 'string') {
        try {
          errorData = JSON.parse(errorData)
        } catch (error) {
          errorData = null
        }
      }
      const apiError = errorData && errorData.error
      throw new Error((apiError && apiError.message) || 'Failed to load PeekAI Nudge report')
    }
    return response.data
  })
}
